import { call, put } from 'redux-saga/effects';
import { showToastMessage } from '~/services/notification';

import api, { makeOptions } from '~/services/api';
import NeighborhoodActions from '../ducks/neighborhood';

const dataLocal = JSON.parse(localStorage.getItem('persist:Spcine'));
// const getAuthData = (state) => state.auth.data;

export function* create(action) {
  try {
    // const authData = yield select(getAuthData);
    const { data: post } = action;
    const { data } = yield call(
      api.post,
      '/neighborhood',
      post,
      makeOptions(dataLocal.auth.data),
    );

    yield put(NeighborhoodActions.createSuccess(data));

    showToastMessage({
      type: 'success',
      text: 'Bairro cadastrado com sucesso',
    });
  } catch (err) {
    yield put(
      NeighborhoodActions.createFailure(err.response.data.error.message),
    );
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* show(action) {
  try {
    // const authData = yield select(getAuthData);
    const { uuid } = action;
    const { data } = yield call(
      api.get,
      `/neighborhood/${uuid}`,
      makeOptions(dataLocal.auth.data),
    );
    yield put(NeighborhoodActions.showSuccess(data));
  } catch (err) {
    yield put(NeighborhoodActions.showFailure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* edit(action) {
  try {
    // const authData = yield select(getAuthData);
    const { data: post } = action;
    const { data } = yield call(
      api.patch,
      `/neighborhood/${post.uuid}`,
      post,
      makeOptions(dataLocal.auth.data),
    );

    yield put(NeighborhoodActions.editSuccess(data));
    showToastMessage({
      type: 'success',
      text: 'Informações atualizadas com sucesso',
    });
  } catch (err) {
    yield put(NeighborhoodActions.editFailure(err.response.data.error.message));
    showToastMessage({
      type: 'error',
      text: err.response.data.error.message,
    });
  }
}

export function* destroy(action) {
  try {
    const { uuid } = action;
    // const authData = yield select(getAuthData);

    const { data: response } = yield call(
      api.delete,
      `neighborhood/${uuid}`,
      makeOptions(dataLocal.auth.data),
    );

    showToastMessage({
      type: 'success',
      text: 'Bairro removido com sucesso.',
    });
    yield put(NeighborhoodActions.deleteSuccess(response));
  } catch (err) {
    yield put(
      NeighborhoodActions.deleteFailure('Erro ao se comunicar com a API.'),
    );
  }
}
